export default __webpack_public_path__ + "static/media/scooter-active.81d95e29.svg";